// extracted by mini-css-extract-plugin
module.exports = {"buttons":"tabs_buttons__7RK4r"};